import {Model} from "@vuex-orm/core";
import BeneficiaryAssignment from "./BeneficiaryAssignment";
import Individual from "./Individual";

export default class LifeInsurance extends Model{
    /* Follow the namespace in the backend */
    static entity = 'Household\\Model\\LifeInsurance';

    static TYPE_PERM = 0;
    static TYPE_TERM = 1;


    static TYPE_LABELS = {
        [LifeInsurance.TYPE_PERM]: 'Perm',
        [LifeInsurance.TYPE_TERM]: 'Term'
    }

    static fields() {
        return {
            id: this.attr(null),
            individual_id: this.attr(''),
            policy_number: this.attr(''),
            name: this.attr(null),
            household_id: this.number(0),
            type_cd: this.attr(''),
            carrier: this.attr(''),
            cash_value: this.number(0),
            death_benefit: this.number(0),
            monthly_cost: this.number(0),
            individual: this.belongsTo(Individual, 'individual_id'),
            beneficiaryAssignments: this.morphMany(BeneficiaryAssignment, 'assignable_id', 'assignable_type'),
        }
    }

    get type() {
        return LifeInsurance.entity;
    }

    get typeLabel() {
        return LifeInsurance.TYPE_LABELS[this.type_cd];
    }

    get ownerLabel() {
        return this.individual ? this.individual.name : 'n/a';
    }

    get accountsOverviewName() {
        return this.policy_number ?? this.name ?? this.ownerLabel
    }

    get accountsOverviewValue() {
        return this.cash_value;
    }
}
